export default function ReportApi({ makeRequest, buildRequest, baseUrl = '' }) {
    
    // Retrieve finance report as an Excel document (Blob)
    function getFinanceReport(DateFrom, DateTo, FileTypeId) {
        return buildRequest().then(function (req) {
            return req
                .get(`${baseUrl}/report/financereport?startDate=${DateFrom}&endDate=${DateTo}&fileTypeId=${FileTypeId}`,
                    { responseType: 'blob' })
                .then(response => {
                    const data = response.data || response;
                    if (data instanceof Blob) {
                        return data;
                    }
                    // Default to XLSX MIME type when constructing Blob
                    return new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                });
        });
    }

    // Retrieve cash banking report
    function getCashBankingReport(centreIds, date) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post(`${baseUrl}/report/cashbankingreport`, {
                centreIds,
                date
            }));
        });
    }

    // Retrieve EFTPOS banking report
    function getEftposBankingReport(centreIds, date) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post(`${baseUrl}/report/eftposbankingreport`, {
                centreIds,
                date
            }));
        });
    }

    return {
        getFinanceReport,
        getCashBankingReport,
        getEftposBankingReport
    };
}
